import styled from 'styled-components';
import { colors } from 'syf-component-library/defaultTheme';
const PromptText = styled.div `
  margin: 0 0 15px 0;
  font-size: ${props => props.theme.fontSizes.promptText};
  max-width: 290px;
`;
const ControlWrapper = styled.div `
  width: 275px;  
  margin: 10px 0 0 0;
  &&& {
    .iva-text-input-field-container > :first-child {
    box-shadow: 0 0 0
      ${({ disabled, hasError }) => {
    if (disabled)
        return '1px #949494';
    if (hasError)
        return '2px' + colors.error;
    return '1px #838383';
}};
    &:hover {
      ${({ hasError, disabled }) => hasError || disabled ? '' : 'box-shadow: 0 0 0 2px #838383'}
    }
    cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'text'};
  background-color: ${({ disabled }) => disabled ? '#949494' : colors.white};
  &:focus-within {
    box-shadow: 0 0 0 2px
      ${({ hasError, theme }) => (hasError ? colors.error : theme.field.focus)};
  }
  }
`;
export { ControlWrapper, PromptText };
